import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Header, Actions, Link } from '@gasbuddy/react-components';
import { Trans, useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';

export default function DeleteStationFromFavorites({
  favoriteListName,
  onDeleteFromFavorites,
  onCancel,
  error,
}) {
  const { t } = useTranslation(['favorites', 'miscellaneous']);
  return (
    <Fragment>
      <Header as="h3">{t('removeFromFavorites')}</Header>
      <Text as="p">
        <Trans i18nKey="favorites:confirmRemoveFromList" values={{ favoriteListName }}>
          Are you sure you want to remove this station from your <strong>&quot;{ favoriteListName }&quot;</strong> favorite list?
        </Trans>
      </Text>
      {!!error && (
        <Text as="p" color="orange">
          {error}
        </Text>
      )}
      <br />
      <Actions>
        <Actions.Button
          primary
          onClick={onDeleteFromFavorites}
          desktop={6}
        >
          {t('removeStation')}
        </Actions.Button>
        <Actions.Action>
          <Link uppercase onClick={onCancel}>
            {t('actions.cancel', { ns: 'miscellaneous' })}
          </Link>
        </Actions.Action>
      </Actions>
    </Fragment>
  );
}

DeleteStationFromFavorites.propTypes = {
  favoriteListName: PropTypes.string.isRequired,
  onDeleteFromFavorites: PropTypes.func,
  onCancel: PropTypes.func,
  error: PropTypes.string,
};

DeleteStationFromFavorites.defaultProps = {
  onDeleteFromFavorites: noop,
  onCancel: noop,
  error: undefined,
};
